/**
 * Disables the context menu for all video elements on the page.
 */
window.addEventListener('contextmenu', function(event) {
    if(event.target.nodeName.toLowerCase() === 'video'){
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
});
